import { useWorkspace } from '@/composables/useWorkspace';
import { getTrafficSourcesApiRequest } from '@/services/api/traffic-sources-api';
import { useStore } from '@/store';

export const populateTrafficSourcesStoreCacheApiRequest = async () => {
  const store = useStore();
  const payload = await getTrafficSourcesApiRequest({
    status: 'active',
    limit: '200',
    orderBy: 'updated',
    orderDirection: 'desc',
    columns: ['name', 'id', 'workspaceId'],
  });
  store.cache.populateTrafficSourcesCache(payload);
  return payload;
};

export const updateTrafficSourcesStoreCacheApiRequest = async ({
  workspaceId,
}: {
  workspaceId: string;
}) => {
  const store = useStore();
  const workspaceApi = useWorkspace();
  const payload = await getTrafficSourcesApiRequest({
    status: 'active',
    limit: '200',
    orderBy: 'updated',
    orderDirection: 'desc',
    columns: ['name', 'id', 'workspaceId'],
    workspaceIds: [...new Set([workspaceId, ...workspaceApi.allPublicWorkspacesIds.value])],
  });
  store.cache.updateTrafficSourcesCache({
    workspaceId,
    data: payload,
  });
  return payload;
};
